import { LogoMark } from "@/components/Logo";
import { Typography } from "@/components/ui/Typography";

export function OfflinePage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 dark:bg-slate-900 px-4">
      <div className="text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-slate-100 mb-6">
          <svg className="h-10 w-10 text-slate-400" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z" />
          </svg>
        </div>
        <LogoMark size={48} className="mx-auto mb-4" />
        <Typography variant="h1" className="mb-2">You&apos;re offline</Typography>
        <p className="text-slate-500 dark:text-slate-400 text-center max-w-sm mx-auto mb-8 leading-relaxed">
          It looks like you&apos;ve lost your internet connection. Some features may be
          unavailable until you&apos;re back online.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-xl bg-primary-600 px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-primary-600/20 hover:bg-primary-700 active:scale-[0.98] transition-all"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
